/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Injector, Input } from '@angular/core';
import { type ColumnDef, type TableConfig, I18nService, TableAbstract, UtilService } from '@dm/core';
import { eventType, infigo } from '@dm/live-material-infigo';
import { type Dtree } from 'app/common/types/mo';
import { DtreeStrService } from 'app/feature/service/file-service/dtree/dtree-str.service';
import { type SearchObj } from 'app/feature/share/global-search/global-search-str.service';

import { InfigoService } from '../../../infigo.service';

@Component({
    selector: 'app-member-dtree-table',
    templateUrl: './member-dtree-table.component.html',
})
export class MemberDtreeTableComponent extends TableAbstract<Dtree> implements OnInit {
    @Input() data;
    @Input() loading = false;
    // 表格行配置对象
    tableColumnDefs: ColumnDef[];
    // 表格总配置对象
    tableConfig: TableConfig;
    jumpPath: SearchObj;

    constructor(
        private i18n: I18nService,
        public str: DtreeStrService,
        private utilService: UtilService,
        private infigoService: InfigoService,
        injector: Injector,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.initTable();
    }

    initBtns(): void {
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'NAME',
                header: this.i18n.get('common.name_column'),
                filterType: 'search',
                filterTrim: false,
                sortable: true,
                onClick: (data: any) => this.setRouterPath(data),
            },
            {
                field: 'ID',
                header: this.i18n.get('common.ID_column'),
                hidden: true,
            },
            {
                field: 'securityStyle', // 安全模式
                header: this.i18n.get('service.dtree_task_create_securityStyle_lab'),
                hidden: true,
                render: (value): string => this.utilService.getLabelFromOptions(this.str.securityOpts, value),
            },
            {
                header: this.i18n.get('common.share_lab'),
                field: 'shareTypes',
                // filterType: 'dropdown', // 暂不支持
                // options: this.str.shareOpts,
                render: (value): any => {
                    const result: any = {};
                    // 构造成{ NFS: true }的形式，方便在模板中使用
                    if (value) {
                        value.forEach((item) => result[item] = true);
                    }
                    return result;
                },
            },
            {
                header: this.i18n.get('common.quota_lab'),
                field: 'quotaCfgCount',
                render: (value): number => Number(value),
            },
        ];

        this.tableConfig = {
            dataKey: 'ID',
            motion: false,
            rows: 5,
        };
    }

    setRouterPath(value: { ID: any; NAME: any }): void {
        this.jumpPath = {
            id: value.ID,
            name: value.NAME,
            precisionType: 'dtree',
            COMBINATION: '',
        };
        const routerEvent = this.infigoService.transformSearchParams(this.jumpPath);
        infigo.dispatch(eventType.CLICK_LIST_ITEM, routerEvent);
    }
}
